import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/auth-context';
import styles from './Header.module.css';

type NavItem = {
  readonly path: string;
  readonly label: string;
};

const NAV_ITEMS: ReadonlyArray<NavItem> = [
  { path: '/', label: 'home' },
  { path: '/forum', label: 'forum' },
  { path: '/autonomy', label: 'autonomy' },
  { path: '/pools', label: 'pools' },
  { path: '/status', label: 'status' },
  { path: '/protocol', label: 'protocol' },
  { path: '/docs', label: 'docs' },
];

const Header = (): React.ReactElement => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, signOut } = useAuth();

  const currentPath = location.pathname;

  return (
    <header className={styles.header}>
      <a
        href="#/"
        className={styles.logo}
        data-testid="nav-logo"
        onClick={(e): void => {
          e.preventDefault();
          void navigate('/');
        }}
      >
        EVENT<span className={styles.logoDot}>.</span>BLACK
      </a>
      <nav className={styles.navScroll}>
        {NAV_ITEMS.map((item) => (
          <button
            key={item.path}
            data-testid={`nav-${item.label}`}
            aria-current={currentPath === item.path ? 'page' : undefined}
            className={`${styles.navLink}${currentPath === item.path ? ` ${styles.active}` : ''}`}
            onClick={(): void => { void navigate(item.path); }}
          >
            {item.label}
          </button>
        ))}
        {isAuthenticated ? (
          <>
            <button
              data-testid="nav-dashboard"
              className={styles.btn}
              onClick={(): void => { void navigate('/dashboard'); }}
            >
              dashboard
            </button>
            <button
              data-testid="nav-signout"
              className={styles.btn}
              onClick={(): void => { signOut(); void navigate('/'); }}
            >
              sign out
            </button>
          </>
        ) : (
          <button
            data-testid="nav-signin"
            className={`${styles.btn} ${styles.btnPrimary}`}
            onClick={(): void => { void navigate('/oauth/signup'); }}
          >
            sign in
          </button>
        )}
      </nav>
    </header>
  );
};

export { Header };
